/**
 * User agents routed through prerender in CloudFront.
 * Keep this list aligned with `infra/cloudformation/prerender-cloudfront.yaml`.
 */
export const PRERENDER_USER_AGENT_REGEX =
  /googlebot|adsbot-google|Feedfetcher-Google|bingbot|yandex|baiduspider|Facebot|facebookexternalhit|twitterbot|rogerbot|linkedinbot|embedly|quora link preview|showyoubot|outbrain|pinterest|slackbot|vkShare|W3C_Validator|redditbot|applebot|whatsapp|flipboard|tumblr|bitlybot|skypeuripreview|nuzzel|discordbot|google page speed|qwantify|pinterestbot|bitrix link preview|xing-contenttabreceiver|chrome-lighthouse|telegrambot|Perplexity|OAI-SearchBot|ChatGPT|GPTBot|ClaudeBot|Amazonbot|integration-test/i;

/**
 * Safely read the current browser user agent string.
 * @returns User agent string or empty string when unavailable.
 */
export const getBrowserUserAgent = (): string => {
  if (typeof navigator === "undefined") {
    return "";
  }
  return navigator.userAgent || "";
};

/**
 * Determine whether a user agent should be treated as a prerender bot.
 * @param userAgent - Optional user agent override.
 * @returns True when the user agent matches the prerender list.
 */
export const isPrerenderUserAgent = (userAgent?: string): boolean => {
  const resolvedUserAgent =
    typeof userAgent === "string" && userAgent.trim().length > 0
      ? userAgent
      : getBrowserUserAgent();

  if (!resolvedUserAgent) {
    return false;
  }

  return PRERENDER_USER_AGENT_REGEX.test(resolvedUserAgent);
};
